<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">
        <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['name', { rules: [{ required: true, message: '请输入姓名' }] }]"
            name="name"
            placeholder="请输入姓名"
          />
        </a-form-item>
        <a-form-item label="职位" :labelCol="labelCol" :wrapperCol="wrapperCol" help="注：英文逗号隔开">
          <a-textarea
            rows="4"
            name="title"
            placeholder="请输入职位"
            v-decorator="['title', { rules: [{ required: true, message: '请输入职位' }] }]"
          />
        </a-form-item>

        <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            rows="4"
            name="desc"
            placeholder="请输入简介"
            v-decorator="['desc', { rules: [{ required: true, message: '请输入简介' }] }]"
          />
        </a-form-item>
        <a-form-item label="头像" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <img-upload
            name="avatar"
            v-decorator="['avatar', { rules: [{ required: true, message: '请输入简介' }] }]"
          />
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="是否在前端展示，默认展示">
          <a-switch
            checked-children="展示"
            un-checked-children="隐藏"
            name="state"
            v-decorator="[
              'state',
              {
                valuePropName: 'checked',
                initialValue: true
              }
            ]"
          />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-button :loading="formLoading" @click="handleOnSubmit(setFormData)" type="primary">提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { ImgUpload, UEditor, GoBack } from '@/components'
import { form, select } from '@/mixins'
import { requestData } from '@/api/api'

const fields = ['name', 'title', 'avatar', 'desc', 'state']
const apiList = {
    getInfo: '/settings/employee/',
    create: '/settings/employee/create'
}
export default {
    name: 'AtpForm',
    mixins: [form, select],
    components: {
        ImgUpload,
        UEditor,
        GoBack
    },
    data () {
        return {
            fields,
            apiList
        }
    },
    mounted () {
      if (this.$route.params.id) {
            apiList.update = '/settings/employee/' + this.$route.params.id
            this.getFormData(this.$route.params.id, function (values) {
                values.state = values.state === 1
            }) // 获取编辑信息
        }
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-28 15:51:55
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description: 整理表单数据
         * @param  {*}
         * @return {*}
         * @param {*} values
         */
        setFormData (values) {
            values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
        },
        /**
         * 表单提交
         * @param {*} e
         * @jdy
         * @2021-4-14
         */
        handleOnSubmit (callback) {
            const that = this
            const { apiList } = this

            that.form.validateFields((err, values) => {
                if (!err) {
                    that.formLoading = true // 表单加载
                    if (callback) {
                        callback(values)
                    }
                    let method = 'post'
                    let url = apiList.create
                    if (this.$route.params.id) {
                        method = 'put'
                        url = apiList.update
                    }
                    requestData(url, method, values)
                        .then(res => {
                            that.$notification.success({
                                message: res.msg
                            })
                        })
                        .finally(() => {
                            that.formLoading = false // 执行完加载关闭
                        })
                }
            })
        }
    }
}
</script>
